import React, {Component} from 'react';
import {getText} from '../../../../../helpers/localization';
import marketStyle from '../css/marketsSoccer3.css';
import OddsCardSoccer3 from './oddsCardSoccer3';

class HandicapSoccer3 extends Component {
    render() {
        let store = this.props.store;
        let markets = this.props.markets;
        let selectedEvent = this.props.selectedEvent;

        let handicapMarkets = [];
        for (let i = 0; i < markets.length; i += 3) {

            //This is provided to show Team Name instead of WIN/LOSE
            if (markets[i].selection.toLowerCase() === 'win')
                markets[i].selection = selectedEvent.teamOne;

            if (markets[i + 2].selection.toLowerCase() === 'lose')
                markets[i + 2].selection = selectedEvent.teamTwo;

            handicapMarkets.push(<div className={marketStyle.marketGroup} key={i}>
                <div className={marketStyle.scoreGroupHandicapPrefix}>
                    {i === 0 ? <span className={marketStyle.marketLabel}>{getText('+1G', this.props.store)}</span> : ''}
                </div>
                <div className={marketStyle.scoreGroupHandicap}>
                    <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                        <span>1</span>
                    </div>
                    <div className={marketStyle.oddsContainerSmall}>
                        <OddsCardSoccer3 store={store} market={markets[i]}/>
                    </div>
                </div>
                <div className={marketStyle.scoreGroupHandicap}>
                    <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                        <span>X</span>
                    </div>
                    <div className={marketStyle.oddsContainerSmall}>
                        <OddsCardSoccer3 store={store} market={markets[i + 1]}/>
                    </div>
                </div>
                <div className={marketStyle.scoreGroupHandicap}>
                    <div className={`${marketStyle.marketLabelSmall} ${marketStyle.marketLabel}`}>
                        <span>2</span>
                    </div>
                    <div className={marketStyle.oddsContainerSmall}>
                        <OddsCardSoccer3 store={store} market={markets[i + 2]}/>
                    </div>
                </div>
                <div className={marketStyle.scoreGroupHandicapPrefix}>
                    {i !== 0 ? <span className={marketStyle.marketLabel}>{getText('+1G', this.props.store)}</span> : ''}
                </div>
            </div>);
        }
        return (
            <div>
                {handicapMarkets}
            </div>
        );
    }
}

export default HandicapSoccer3;



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/modules/football/components/handicapSoccer3.js